import { useEffect, useState } from "react";
import { BellRing, HandHeart, MapPin } from "lucide-react";
import { api } from "@/lib/api";
import { localToday } from "@/lib/calendar";
import { KIND, timeRange } from "@/lib/dates";
import { AlertBanner } from "./EventStatus";

const childFor = (code) => JSON.parse(localStorage.getItem(`dp-rsvp-${code.toUpperCase()}`) || "{}").child || "";

export const BoardBanners = ({ code }) => {
  const [board, setBoard] = useState({ events: [], volunteers: [] });
  const [child, setChild] = useState(() => childFor(code));
  useEffect(() => {
    const load = () => { setChild(childFor(code)); api.board(code).then(setBoard).catch(() => {}); };
    load();
    window.addEventListener("dp-board-change", load);
    return () => window.removeEventListener("dp-board-change", load);
  }, [code]);
  const today = board.events.filter((e) => e.date === localToday() && e.status !== "canceled");
  return (
    <>
      <AlertBanner events={board.events} />
      <ReminderBanner today={today} roles={board.volunteers || []} child={child} />
      <TodayBanner today={today} />
    </>
  );
};

const ReminderBanner = ({ today, roles, child }) => {
  const me = child.toLowerCase();
  const jobs = !me ? [] : today.flatMap((e) => roles
    .filter((r) => (r.applies_to || []).includes(e.kind) && r.names.some((n) => n.toLowerCase() === me))
    .map((r) => ({ role: r.label, event: e })));
  if (!jobs.length) return null;
  return (
    <div className="reminder-banner" data-testid="volunteer-reminder-banner">
      <HandHeart size={26} className="shrink-0 today-bell" />
      <div className="min-w-0 space-y-1">
        <p className="font-heading text-2xl font-extrabold uppercase leading-none">Your job today</p>
        {jobs.map((j) => (
          <p key={`${j.role}-${j.event.id}`} className="font-bold" data-testid="volunteer-reminder">
            {child}'s family is {j.role} for {j.event.title} · {timeRange(j.event)}
          </p>
        ))}
      </div>
    </div>
  );
};

const TodayBanner = ({ today }) => {
  if (!today.length) return null;
  return (
    <div className="today-banner" data-testid="today-banner">
      <BellRing size={26} className="shrink-0 today-bell" />
      <div className="min-w-0 space-y-1">
        <p className="font-heading text-2xl font-extrabold uppercase leading-none">Today</p>
        {today.map((e) => (
          <p key={e.id} className="font-bold" data-testid="today-event">
            {KIND[e.kind].label}: {e.title} · {timeRange(e)}
            {e.location && <span className="inline-flex items-center gap-1 ml-2"><MapPin size={14} />{e.location}</span>}
          </p>
        ))}
      </div>
    </div>
  );
};
